import React from 'react'
import PropTypes from 'prop-types'
import { reduxForm } from 'redux-form'
import Fields from './fields'
import validate from './validator'

const PassportPaymentForm = ({
  planDetails,
  handleSubmit,
  onSubmit,
  clientApplyCode,
  form,
  invitationId,
  plan,
  place,
}) => {
  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Fields
        planDetails={planDetails}
        clientApplyCode={clientApplyCode}
        form={form}
        invitationId={invitationId}
        plan={plan}
        place={place}
      />
    </form>
  )
}

PassportPaymentForm.propTypes = {
  planDetails: PropTypes.object,
  onSubmit: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  clientApplyCode: PropTypes.func,
  form: PropTypes.string,
  invitationId: PropTypes.string,
  plan: PropTypes.string,
  place: PropTypes.string,
}

export default reduxForm({ validate })(PassportPaymentForm)
